var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8333 7.5H9.16667C6.86548 7.5 5 9.36548 5 11.6667V30.8333C5 33.1345 6.86548 35 9.16667 35H30.8333C33.1345 35 35 33.1345 35 30.8333V11.6667C35 9.36548 33.1345 7.5 30.8333 7.5Z",
    stroke: "#008CB7",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6665 4.16666V10.8333",
    stroke: "#008CB7",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 4.16666V10.8333",
    stroke: "#008CB7",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.6667H35",
    stroke: "#008CB7",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 25L17.5002 29.1667L26.6668 20.8333",
    stroke: "#008CB7",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheckIcon);
export default __webpack_public_path__ + "static/media/calendarCheckIcon.57a09a84993b9de7aae6bb6f4f1df14f.svg";
export { ForwardRef as ReactComponent };